document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname === '/cart') {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const bundleTitles = [
          "Mental Health Bundle",
          "Joint Health",
          "Immune System",
          "Blood Sugar Bundle",
          "Heart Health"
        ];
        const hasNonBundle = cart.items.some(item => !bundleTitles.includes(item.product_title));
        if (hasNonBundle) {
          trackIntelligemsEventCartProductReview('standalone_product_in_cart');
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }
})

function trackIntelligemsEventCartProductReview(event) {
  console.info('Track IG Event: ', event)
  window.igEvents = window.igEvents || []
  window.igEvents.push({
    event: event,
  })
}